import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import lazyImport from '@Utils/lazyImport';

import { RouteInfo } from '../appRoutes';

const CompanyPage = lazyImport(() => import('./CompanyPage'));

const routes: RouteInfo[] = [
  {
    path: RouteConfig.Company.template,
    component: CompanyPage,
    title: Messages.companyAdsPage,
    exact: false,
  },
];

export default routes;
